$ = jQuery;

function get_uf_by_ddd(ddd) {

  switch (ddd) {
    case 11:
    case 12:
    case 13:
    case 14:
    case 15:
    case 16:
    case 17:
    case 18:
    case 19:
      return 'SP';

    case 21:
    case 22:
    case 24:
      return 'RJ';

    case 27:
    case 28:
      return 'ES';

    case 31:
    case 32:
    case 33:
    case 34:
    case 35:
    case 37:
    case 38:
      return 'MG';

    case 41:
    case 42:
    case 43:
    case 44:
    case 45:
    case 46:
      return 'PR';

    case 47:
    case 48:
    case 49:
      return 'SC';

    case 51:
    case 53:
    case 54:
      return 'RS';

    case 61:
      return 'DF';

    case 63:
      return 'TO';

    case 62:
    case 64:
      return 'GO';

    case 65:
    case 66:
      return 'MT';

    case 67:
      return 'MS';

    case 68:
      return 'AC';

    case 69:
      return 'RO';

    case 71:
    case 73:
    case 74:
    case 75:
    case 77:
      return 'BA';

    case 79:
      return 'SE';

    case 81:
    case 87:
      return 'PE';

    case 82:
      return 'AL';

    case 83:
      return 'PB';

    case 84:
      return 'RN';

    case 85:
    case 88:
      return 'CE';

    case 86:
    case 89:
      return 'PI';

    case 91:
    case 93:
    case 94:
      return 'PA';

    case 92:
    case 97:
      return 'AM';

    case 95:
      return 'RR';

    case 96:
      return 'AP';

    case 98:
    case 99:
      return 'MA';
  }

}

jQuery(document).ready(function($) {

    var formConfirmLead = $('.form-confirm-lead');
    var userCity = $('#user_city').val();
    var offerStates = $('#offer_states').val().split(',');
    var candidateLeadId = $('#candidate_lead_id').val();
    var offerId = $('#offer_id').val();
    var cityElement = formConfirmLead.find('#city');
    var phoneElement = formConfirmLead.find('#phone');

    //Eventos campo concessionária
    if (cityElement.length > 0) {

        cityElement.change(function changeCityElement (event) {
          var cityName = $(this).val();
          var dealerships = $(this).closest('.form').find('.dealerships');

          if (cityName) {
            dealerships.show();
            dealerships.find('.radio').each(function (index, el) {
              var elcityName = $(el).data('city');

              //Resetando todos os check de concessionárias
              $(el).find('input:radio').prop('checked', false);

              if (cityName.length > 0) {
                if (cityName != elcityName) {
                  $(el).hide();
                } else {
                  $(el).show();
                }
                dealerships.prop('disabled', false);
              } else {
                $(el).hide();
                dealerships.val('');
                dealerships.prop('disabled', true);
              }
            });
          } else {
            dealerships.hide();
            dealerships.find('input:radio').removeAttr('checked');
          }
        });
      }

    //Seta cidade
    $("#city > option").each(function(index, el) {
        //se a cidade do cep tiver uma concessionário associada a oferta seleciona a cidade automaticamente
        if(el.value && el.value.trim().toLowerCase() == userCity.trim().toLowerCase() ) {
            $(el).prop('selected', true);
            $("#city").trigger( "change");
        }
    });

    //Máscara campo telefone
    phoneElement.keydown(function () {
      var a = function (e) {
        return 11 === e.replace(/\D/g, "").length ? "(00) 00000-0000" : "(00) 0000-00009";
      },
        t = {
          onKeyPress: function (e, t, o, r) {
            o.mask(a.apply({}, arguments), r);
          }
        };

      $(this).mask(a, t);
    });

    //Setando classes para a validação do formulário
    $.validator.setDefaults({
      highlight: function (e) {
        $(e).closest(".form-group").addClass("has-danger");
      },
      unhighlight: function (e) {
        $(e).closest(".form-group").removeClass("has-danger");
      },
      errorElement: "div",
      errorClass: "form-control-feedback small",
      errorPlacement: function (e, a) {
        a.closest(".form-group").length ? e.appendTo(a.closest(".form-group")) : e.insertAfter(a);
      }
    });

    //Adicionando método para verificar validar o telefone
    $.validator.addMethod("phone_validator", function (telefone, elemento) {
      //retira todos os caracteres menos os numeros
      telefone = telefone.replace(/\D/g, '');

      if (telefone === "") {
        return true;
      }

      //verifica se tem a qtde de numero correto
      if (!(telefone.length >= 10 && telefone.length <= 11)) return false;

      //Se tiver 11 caracteres, verificar se começa com 9 o celular
      if (telefone.length == 11 && parseInt(telefone.substring(2, 3)) != 9) return false;

      //verifica se não é nenhum numero digitado errado (propositalmente)
      for (var n = 0; n < 10; n++) {
          //um for de 0 a 9.
          //estou utilizando o metodo Array(q+1).join(n) onde "q" é a quantidade e n é o
          //caractere a ser repetido
          if (telefone == new Array(11).join(n) || telefone == new Array(12).join(n)) return false;
      }

      //DDDs validos
      var codigosDDD = [11, 12, 13, 14, 15, 16, 17, 18, 19,
          21, 22, 24, 27, 28, 31, 32, 33, 34,
          35, 37, 38, 41, 42, 43, 44, 45, 46,
          47, 48, 49, 51, 53, 54, 55, 61, 62,
          64, 63, 65, 66, 67, 68, 69, 71, 73,
          74, 75, 77, 79, 81, 82, 83, 84, 85,
          86, 87, 88, 89, 91, 92, 93, 94, 95,
          96, 97, 98, 99];

      //verifica se o DDD é valido
      if (codigosDDD.indexOf(parseInt(telefone.substring(0, 2))) == -1) return false;
      //se passar por todas as validações acima, então está tudo certo

      return true;
    });

    $.validator.addMethod("ddd_region_offer", function (telefone, elemento) {

      //retira todos os caracteres menos os numeros
      telefone = telefone.replace(/\D/g, '');

      //verifica estado/oferta
      var ddd = parseInt(telefone.substring(0, 2));
      var estado = get_uf_by_ddd(ddd);

      if(offerStates && estado && !offerStates.includes(estado)) {
        return false;
      }

      return true;

    });

    //validação
    formConfirmLead.each(function () {

      $(this).validate({
        onfocusout: function (element, event) {
          this.element(element);
        },
        onclick: function (element, event) {
          this.element(element);
        },
        rules: {
          dealership: {
            required: true,
            minlength: 1,
          },
          phone: {
            phone_validator: true,
            ddd_region_offer: true
          }
        },
        messages: {
          phone: {
            required: "Campo obrigatório",
            phone_validator: "Informe um telefone válido",
            ddd_region_offer: "Esta oferta não é válida para a região deste DDD"
          },
          city: "Por favor escolha uma cidade",
          dealership: "Por favor escolha uma concessionária"
        }
      });
    });

    //submit
    formConfirmLead.submit(function (event) {
      event.preventDefault();

      formConfirmLead = $('.form-confirm-lead');
      dealership_id = formConfirmLead.find('.dealerships input:checked').val();
      offerId = $('#offer_id').val();
      submitBtn = $('#confirm-lead-submit');
      confirmLeadDiv = $('.jc-confirm-lead-div');
      phone = formConfirmLead.find('#phone').val();

      if (formConfirmLead.valid()) {

        $.ajax({
            url: ajaxHandler.url_leads + '/api/jornaldocarro/v1/confirm-lead-email',
            type: 'POST',
            data: {
            action: 'jc_confirm_lead_email',
            candidateLeadId: candidateLeadId,
            offer_id: offerId,
            dealership_id: dealership_id,
            phone: phone
            },
            beforeSend: function(){
              submitBtn.val('Enviando...');
              submitBtn.prop('disabled', true);
            },
            success: function(response) {
                //carrega página de obrigado
                confirmLeadDiv.html(response.data.template);
            },
            error: function(data) {
            },
            complete: function() {
              submitBtn.val('Consultar Oferta');
              submitBtn.prop('disabled', false);
            }
        });
      }

    });

});

